/**
 * Which Kiirhindamise lühiaruanne malls a quick valuation may be exported with (RED-356).
 *
 * Mirrors `App\Support\QuickValuationTemplates::allowedTypes()`, which filters the
 * result page's dropdown and refuses a disallowed mall at export time. The history
 * page receives every mall the flag offers (one list for all rows), so it applies
 * the same rule per row here — keep the two in step.
 *
 *   - flag `qv-statistical-report` OFF → the kohandustabel mall only (today's list);
 *   - flag ON, direct result (no comparables) → the statistical-model mall only;
 *   - flag ON, comparables result → both malls, kohandustabel first (Rasmus 14.10).
 *
 * The server sends the malls kohandustabel first; filtering keeps that order.
 */
export const TEMPLATE_TYPE_QUICK_VALUATION = 'QUICK_VALUATION'
export const TEMPLATE_TYPE_QUICK_VALUATION_MODEL = 'QUICK_VALUATION_MODEL'

// A template without `type` comes from a payload that predates the second mall,
// when every quick-valuation template was the kohandustabel one.
const typeOf = template => template?.type ?? TEMPLATE_TYPE_QUICK_VALUATION

/**
 * @param {Array<{id: number, description: string, type?: string}>|null|undefined} templates
 * @param {{valuation_mode?: string}|null|undefined} prediction the row's persisted prediction
 * @param {boolean} statisticalReportEnabled the `qv-statistical-report` flag for this user
 * @returns {Array<{id: number, description: string, type?: string}>}
 */
export const templatesForValuation = (templates, prediction, statisticalReportEnabled) => {
  if (!Array.isArray(templates)) return []

  let allowed = [TEMPLATE_TYPE_QUICK_VALUATION]
  if (statisticalReportEnabled) {
    allowed = prediction?.valuation_mode === 'direct'
      ? [TEMPLATE_TYPE_QUICK_VALUATION_MODEL]
      : [TEMPLATE_TYPE_QUICK_VALUATION, TEMPLATE_TYPE_QUICK_VALUATION_MODEL]
  }

  return templates.filter(template => allowed.includes(typeOf(template)))
}

/**
 * The mall the short-report dialog pre-selects on open: the only one offered,
 * or, when a comparables result is offered both kinds, its only kohandustabel
 * mall (the default, RED-356). Null when the user has to choose: several malls
 * of the same kind, as before RED-356.
 *
 * @param {Array<{id: number, description: string, type?: string}>|null|undefined} templates
 * @returns {number|null}
 */
export const defaultTemplateId = (templates) => {
  if (!Array.isArray(templates) || templates.length === 0) return null
  if (templates.length === 1) return templates[0].id

  const kohandustabel = templates.filter(template => typeOf(template) === TEMPLATE_TYPE_QUICK_VALUATION)

  return kohandustabel.length === 1 ? kohandustabel[0].id : null
}
